import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Calendar, Close } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { Input } from "@air/primitive-input";
import { tailwindMerge } from "@air/tailwind-variants";
import { forwardRef } from "react";
export const DateInputField = /*#__PURE__*/ forwardRef((param, ref)=>{
    let { showCalendarIcon = true, className, size, onClear, ...props } = param;
    const showClearIcon = !!onClear && !!props.value;
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative flex",
        children: [
            showCalendarIcon && /*#__PURE__*/ _jsx(Calendar, {
                className: "absolute left-3 top-1/2 size-4 -translate-y-1/2 text-grey-11"
            }),
            /*#__PURE__*/ _jsx(Input, {
                ref: ref,
                className: tailwindMerge("w-full", showCalendarIcon ? "pl-9" : "", showClearIcon ? "pr-8" : "", className),
                size: size,
                ...props
            }),
            showClearIcon && /*#__PURE__*/ _jsx(IconButton, {
                label: "Clear",
                appearance: "ghost",
                color: "grey",
                icon: Close,
                size: "small",
                onClick: onClear,
                className: "absolute right-1.5 top-1/2 -translate-y-1/2"
            })
        ]
    });
});
DateInputField.displayName = "DateInputField";
